import { useTranslations } from "use-intl";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { parseActualSekAmount } from "./actualSekAmount";

interface ActualSekAmountFieldProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  className?: string;
}

/** The "Actual amount (SEK)" input of every external-settlement modal, with its FIN-1042 error. */
export default function ActualSekAmountField({ id, value, onChange, readOnly, className }: ActualSekAmountFieldProps) {
  const t = useTranslations("consultantMatching.shared");
  // The only refusal parseActualSekAmount produces is "not greater than 0", so the sentence is the catalog's.
  const hasError = parseActualSekAmount(value).error !== null;
  const errorId = `${id}-error`;
  return (
    <div className={className}>
      <Label htmlFor={id}>{t("actualAmount")}</Label>
      <Input
        id={id}
        type="number"
        step="0.01"
        min="0.01"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
        aria-invalid={hasError ? true : undefined}
        aria-describedby={hasError ? errorId : undefined}
        className="mt-1"
      />
      {hasError && (
        <p id={errorId} role="alert" className="mt-1 text-sm text-destructive">
          {t("actualAmountNotPositive")}
        </p>
      )}
    </div>
  );
}
